import {
  SHOPPER_AGENT_GUIDELINE_MAX_COUNT,
  SHOPPER_AGENT_GUIDELINE_MAX_LENGTH,
  ShopperAgentGuidelineTextSchema,
} from "@redotech/redo-shopper-agent-settings-common/guideline-config";
import * as z from "zod";
import {
  promptFixIssueSchema,
  promptFixSchema,
} from "../prompt-helper/prompt-fix";

/** The changes the fix card offers for one issue in a guideline; null when none could be written. */
export const draftShopperAgentGuidelineFix = {
  name: "draftShopperAgentGuidelineFix" as const,
  input: z.object({
    /** Untrimmed, since the issue's offsets index into this text. */
    guideline: z.string().max(SHOPPER_AGENT_GUIDELINE_MAX_LENGTH),
    otherGuidelines: z
      .array(ShopperAgentGuidelineTextSchema)
      .max(SHOPPER_AGENT_GUIDELINE_MAX_COUNT),
    issue: promptFixIssueSchema,
  }),
  output: z.object({ fix: promptFixSchema.nullable() }),
};
